/* ==========================================================================
   KCV2 productkaart — gedrag

   Alle logica staat in dit ene externe bestand met event delegation op
   document. De oude kaart zette ~1100 regels inline script in de HTML, dat
   bij twintig kaarten twintig keer gedownload en geparsed werd.

   Waarom delegation: facets.js vervangt bij elk filter de volledige
   innerHTML van het grid. Handlers die op losse knoppen zijn gebonden,
   verdwijnen dan. Door op document te luisteren overleven ze elke DOM-swap.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__kcv2CardInit) return;
  window.__kcv2CardInit = true;

  var SUCCESS_MS = 1500;

  /* ---------- Winkelwagen ---------- */

  function fetchCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      return r.ok ? r.json() : null;
    }).catch(function () {
      return null;
    });
  }

  function announceCartChange(cart) {
    // Het thema en de KCONV-cart luisteren allebei op dit event.
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'kcv2-card' } }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'kcv2-card' } }));
  }

  function updateCartBadges(cart) {
    if (!cart) return;
    var count = cart.item_count || 0;
    document.querySelectorAll('[data-cart-count], .cart-count, .cart-badge').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
    });
  }

  /* ---------- Knopanimatie (zelfde toestanden als de oude kaart) ---------- */

  function runSuccess(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-success');
    window.setTimeout(function () {
      btn.classList.remove('is-success');
      syncCardStates();
    }, SUCCESS_MS);
  }

  function runError(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('kcv2-shake');
    window.setTimeout(function () {
      btn.classList.remove('kcv2-shake');
    }, 600);
  }

  /* ---------- Toevoegen aan winkelwagen ---------- */

  function handleAdd(form, btn) {
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    var input = form.querySelector('input[name="id"]');
    if (!input || !input.value) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: parseInt(input.value, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        updateCartBadges(cart);
        announceCartChange(cart);
        runSuccess(btn);

        // De bestaande winkelwagenmodal van het thema hergebruiken.
        if (typeof window.KCShowCartModal === 'function') {
          window.KCShowCartModal({
            id: form.getAttribute('data-kcv2-product-id'),
            title: form.getAttribute('data-kcv2-product-title'),
            image: form.getAttribute('data-kcv2-product-image'),
            url: form.getAttribute('data-kcv2-product-url')
          });
        }
      })
      .catch(function () {
        runError(btn);
      })
      .then(function () {
        btn.disabled = false;
      });
  }

  /* ---------- Maximaal bestelbaar aantal ---------- */

  function syncCardStates() {
    var forms = document.querySelectorAll('[data-kcv2-form]');
    if (!forms.length) return;

    fetchCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) return;

      forms.forEach(function (form) {
        var btn = form.querySelector('[data-kcv2-add]');
        var input = form.querySelector('input[name="id"]');
        if (!btn || !input) return;

        var policy = String(form.getAttribute('data-kcv2-inv-policy') || '').toLowerCase();
        var qtyAttr = form.getAttribute('data-kcv2-inv-qty');
        if (policy === 'continue' || qtyAttr === '' || qtyAttr === null) {
          btn.classList.remove('is-maxed');
          return;
        }

        var available = parseInt(qtyAttr, 10);
        if (isNaN(available)) return;

        var vid = String(input.value);
        var inCart = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].variant_id) === vid) inCart = cart.items[i].quantity || 0;
        }

        if (inCart >= available) {
          btn.classList.add('is-maxed');
        } else {
          btn.classList.remove('is-maxed');
        }
      });
    });
  }

  /* ---------- Verlanglijst-hartje opnieuw activeren (spec C2) ----------

     De StockPRO-app bindt zijn hartjes bij DOMContentLoaded en bij
     shopify:section:load. Deze pagina herlaadt het grid via AJAX zodra je
     filtert, dus de hartjes op nieuw ingeladen kaarten zijn daarna dood.
     Dat is de beperking die StockPRO zelf benoemt.

     We lossen het hier op in drie stappen, van net naar minder net:

     1. Een echte re-init-functie van de app aanroepen als die bestaat.
     2. Anders shopify:section:load afvuuren, want daar luistert de app op.
        Dat doen we OP het grid met bubbles, niet op document: listeners die
        event.target respecteren raken dan alleen de nieuwe kaarten en niet
        de hele pagina. Judge.me heeft eerder een offsetParent-fout gegeven
        bij een globale re-init, en dat willen we niet uitlokken.

     De echte oplossing is een event-delegation of re-init hook in de app
     zelf; dan kan stap 2 hier weg. */

  function reinitWishlist(scope) {
    var app = window.WishStock || window.Wishstock || window.wishstock || window.StockPro || window.StockPRO;

    if (app) {
      var fn = app.initHeartButtons || app.reinit || app.init;
      if (typeof fn === 'function') {
        try {
          fn.call(app, scope || document);
          return;
        } catch (e) { /* val terug op het event hieronder */ }
      }
    }

    if (typeof window.initHeartButtons === 'function') {
      try {
        window.initHeartButtons(scope || document);
        return;
      } catch (e) { /* val terug op het event hieronder */ }
    }

    var host = scope || document.getElementById('Product-Grid-Container');
    if (!host) return;
    host.dispatchEvent(new CustomEvent('shopify:section:load', {
      bubbles: true,
      detail: { sectionId: 'kcv2-collection' }
    }));
  }

  /* ---------- Hovervideo op de tweede media (spec C15) ----------

     Is het tweede media-item een video, dan speelt die af zolang de muis op
     de kaart staat, met een maximum van vier seconden — hetzelfde gedrag als
     op de bestaande kc-kaart.

     De bron staat in een data-attribuut en wordt pas bij de eerste hover
     gezet. Anders begint een raster van 24 kaarten meteen aan 24 video's.

     Waarom mouseover/mouseout en niet mouseenter/mouseleave: die laatste
     bubbelen niet en zijn dus niet te delegeren, en delegation is hier nodig
     omdat facets.js het hele grid vervangt. Met de relatedTarget-check
     hieronder gedragen ze zich verder identiek: bewegen binnen dezelfde
     kaart telt niet als opnieuw binnenkomen of vertrekken.

     Let op het gewicht. Liquid geeft van deze video's alleen de 1080p-mp4
     vrij, geen lichtere rendition, dus het bestand is fors. Vandaar drie
     remmen: preload="none" in de markup, een intentievertraging zodat je
     niet downloadt bij het langsvegen van de muis, en pauzeren na vier
     seconden. */

  var HOVER_INTENT_MS = 220;
  var HOVER_VIDEO_MS = 4000;
  var startTimers = new WeakMap();
  var stopTimers = new WeakMap();
  var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;

  function stopHoverVideo(video) {
    window.clearTimeout(startTimers.get(video));
    window.clearTimeout(stopTimers.get(video));
    startTimers.delete(video);
    stopTimers.delete(video);
    try {
      video.pause();
      video.currentTime = 0;
    } catch (err) { /* video nog niet ver genoeg geladen */ }
  }

  function playHoverVideo(video) {
    var src = video.getAttribute('data-kcv2-hover-video-src');
    if (!src) return;

    if (!video.src) {
      video.src = src;
      video.load();
    }

    // muted is nodig voor autoplay zonder klik; het attribuut alleen is in
    // sommige browsers niet genoeg als de node via innerHTML is ingevoegd.
    video.muted = true;

    var playing = video.play();
    if (playing && typeof playing.catch === 'function') {
      playing.catch(function () { /* browser weigert; poster blijft staan */ });
    }

    stopTimers.set(video, window.setTimeout(function () {
      stopHoverVideo(video);
    }, HOVER_VIDEO_MS));
  }

  function hoverVideoIn(card) {
    var video = card.querySelector('[data-kcv2-hover-video-src]');
    if (!video || startTimers.has(video)) return;

    startTimers.set(video, window.setTimeout(function () {
      startTimers.delete(video);
      playHoverVideo(video);
    }, HOVER_INTENT_MS));
  }

  function hoverVideoOut(card) {
    var video = card.querySelector('[data-kcv2-hover-video-src]');
    if (video) stopHoverVideo(video);
  }

  /* ---------- Delegation ---------- */

  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest && e.target.closest('[data-kcv2-card]');
      if (!card || card.contains(e.relatedTarget)) return;
      hoverVideoIn(card);
    });

    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('[data-kcv2-card]');
      if (!card || card.contains(e.relatedTarget)) return;
      hoverVideoOut(card);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-kcv2-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-kcv2-add]');
    if (btn) handleAdd(form, btn);
  });

  /* Het hartje is van de app: klikken niet onderscheppen, alleen zorgen dat
     het niet doorslaat naar het klikvlak van de kaarttitel eronder. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-wishstock-button]')) {
      e.stopPropagation();
    }
  });

  /* ---------- Hydratatie na een DOM-swap ---------- */

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.source === 'kcv2-card') return;
    syncCardStates();
  });

  /* facets.js vuurt dit af nadat het grid opnieuw is opgebouwd. */
  window.addEventListener('collection:filtered', function () {
    syncCardStates();
    reinitWishlist(document.getElementById('Product-Grid-Container'));
  });

  /* Vangnet voor DOM-swaps die geen collection:filtered afvuren, zoals
     "Meer laden" en oneindig scrollen.

     Bewust childList zonder subtree, en zonder attributes: de app past bij
     het activeren zelf classes binnen de hartjes aan. Met subtree zou onze
     re-init die mutatie opvangen en zichzelf opnieuw aanroepen. */

  function observeGrid() {
    var container = document.getElementById('Product-Grid-Container');
    if (!container || !window.MutationObserver) return;

    var pending = null;
    function refresh() {
      window.clearTimeout(pending);
      pending = window.setTimeout(function () {
        syncCardStates();
        reinitWishlist(container);
      }, 120);
    }

    var listObserver = new MutationObserver(refresh);

    function watchList() {
      var list = container.querySelector('[data-kcv2-grid]');
      if (list) listObserver.observe(list, { childList: true });
    }

    // Bij een filterwissel vervangt facets.js de hele ul, dus dan moet de
    // observer opnieuw op het nieuwe element gezet worden.
    new MutationObserver(function () {
      listObserver.disconnect();
      watchList();
      refresh();
    }).observe(container, { childList: true });

    watchList();
  }

  function init() {
    syncCardStates();
    observeGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
